// // client/src/DoctorInfo.js
// import React from 'react';

// const DoctorInfo = () => {
//   return (
//     <div style={styles.container}>
//       <div style={styles.infoContainer}>
//         <h2 style={styles.heading}>Doctor Info</h2>
//         <p style={styles.info}>
//           Find information about gynecologists and nutritionists. This feature is coming soon!
//         </p>
//       </div>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     minHeight: '100vh',
//     fontFamily: "'Poppins', sans-serif",
//     boxSizing: 'border-box',
//   },
//   infoContainer: {
//     backgroundColor: 'rgba(255, 255, 255, 0.9)',
//     padding: '40px',
//     borderRadius: '10px',
//     boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
//     textAlign: 'center',
//     border: '2px solid #ff8c00',
//     width: '100%',
//     maxWidth: '600px',
//   },
//   heading: {
//     fontSize: '28px',
//     color: '#ff8c00',
//     marginBottom: '20px',
//     fontWeight: '600',
//   },
//   info: {
//     fontSize: '16px',
//     color: '#333',
//   },
// };

// export default DoctorInfo;



import React, { useEffect, useState } from 'react';

const DoctorInfo = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Trigger animation when component mounts
    setIsVisible(true);
  }, []);

  return (
    <div style={styles.container}>
      <div 
        style={{
          ...styles.infoContainer,
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
          transition: 'all 0.8s ease-out',
        }}
      >
        <h2 
          style={{
            ...styles.heading,
            animation: 'pulse 2s infinite',
          }}
        >
          Doctor Info
        </h2>
        <p style={styles.info}>
          Find information about gynecologists and nutritionists. This feature is coming soon!
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    fontFamily: "'Poppins', sans-serif",
    boxSizing: 'border-box',
    paddingTop: '90px',
    backgroundImage: 'url(/background.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    position: 'relative',
    zIndex: 1,
    '::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(253, 232, 233, 0.7)',
      zIndex: -1,
    },
    '@keyframes pulse': {
      '0%': {
        transform: 'scale(1)',
      },
      '50%': {
        transform: 'scale(1.05)',
      },
      '100%': {
        transform: 'scale(1)',
      },
    },
  },
  infoContainer: {
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    backdropFilter: 'blur(5px)',
    padding: '40px',
    borderRadius: '10px',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
    border: '2px solid #B15870',
    width: '100%',
    maxWidth: '600px',
    position: 'relative',
    zIndex: 2,
    '&:hover': {
      transform: 'scale(1.02)',
      transition: 'transform 0.3s ease-in-out',
    },
  },
  heading: {
    fontSize: '28px',
    color: '#B85170',
    marginBottom: '20px',
    fontWeight: '600',
    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.1)',
  },
  info: {
    fontSize: '16px',
    color: '#000000',
    lineHeight: '1.6',
    animation: 'fadeIn 1s ease-in',
  },
};

export default DoctorInfo;